module.exports = __webpack_public_path__ + "static/media/bell-school.39b7e76e.svg";